export default __webpack_public_path__ + "static/media/icon_raise_coin.d4170f59.png";